module.exports = __webpack_public_path__ + "static/img/single_good4.a8408da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/single_good4.png
// module id = Kpz2
// module chunks = 1